import { FC, ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ bold: boolean }>()((theme, { bold }) => ({
  chip: {
    borderRadius: '50px',
    display: 'inline-block',
    padding: bold ? '0.25rem 1rem' : '0.25rem 0.5rem',
    fontWeight: bold ? 'bold' : 'normal',
    cursor: 'default',
  },
  variantDisabled: {
    color: 'rgba(150, 150, 150, 1)',
    backgroundColor: 'rgba(178, 178, 178, 0.1)',
  },
  variantSuccess: {
    color: theme.palette.success.main,
    backgroundColor: 'rgba(86, 178, 108, 0.1)',
  },
  variantError: {
    color: theme.palette.error.main,
    backgroundColor: 'rgba(2332, 69, 60, 0.1)',
  },
  small: {
    fontSize: '0.8rem',
    padding: '0.2rem 0.5rem',
  },
  variantInfo: {
    backgroundColor: '#ECC9A2',
  },
  variantTabIndicator: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    display: 'inline-flex',
    padding: '0 6.5px',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

type Props = {
  variant?: 'disabled' | 'success' | 'error' | 'info' | 'tabIndicator';
  children: ReactNode;
  small?: boolean;
  bold?: boolean;
};

const Chip: FC<Props> = ({ children, variant, small, bold = true }) => {
  const { classes } = useStyles({ bold });

  let classname = classes.chip;

  if (small) {
    classname += ` ${classes.small}`;
  }

  if (variant === 'disabled') {
    classname += ` ${classes.variantDisabled}`;
  } else if (variant === 'success') {
    classname += ` ${classes.variantSuccess}`;
  } else if (variant === 'error') {
    classname += ` ${classes.variantError}`;
  } else if (variant === 'info') {
    classname += ` ${classes.variantInfo}`;
  } else if (variant === 'tabIndicator') {
    classname += ` ${classes.variantTabIndicator}`;
  }

  return <span className={classname}>{children}</span>;
};

export default Chip;
